import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { I18nProvider } from "@/lib/i18n";
import { ThemeProvider, useTheme } from "@/contexts/ThemeContext";
import { AccessibilityProvider } from "@/contexts/AccessibilityContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import CalendarPage from "@/pages/Calendar";
import Assets from "@/pages/Assets";
import Journal from "@/pages/Journal";
import Fishing from "@/pages/Fishing";
import Places from "@/pages/Places";
import PhotoMap from "@/pages/PhotoMap";
import Weather from "@/pages/Weather";
import Commercial from "@/pages/Commercial";
import Maintenance from "@/pages/Maintenance";
import Invoices from "@/pages/Invoices";
import Documents from "@/pages/Documents";
import Reports from "@/pages/Reports";
import Intelligence from "@/pages/Intelligence";
import TrashPage from "@/pages/TrashPage";
import Settings from "@/pages/Settings";
import Approvals from "@/pages/Approvals";
import Manual from "@/pages/Manual";
import DamageReports from "@/pages/DamageReports";

import "@/App.css";

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AccessibilityProvider>
          <I18nProvider>
            <AuthProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Navigate to="/app/dashboard" replace />} />
                <Route path="/login" element={<Login />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route
                  path="/app/*"
                  element={
                    <ProtectedRoute>
                      <Layout>
                        <Routes>
                          <Route path="dashboard" element={<Dashboard />} />
                          <Route path="calendar" element={<CalendarPage />} />
                          <Route path="assets" element={<Assets />} />
                          <Route path="journal" element={<Journal />} />
                          <Route path="fishing" element={<Fishing />} />
                          <Route path="map" element={<PhotoMap />} />
                          <Route path="places" element={<Places />} />
                          <Route path="commercial" element={<Commercial />} />
                          <Route path="maintenance" element={<Maintenance />} />
                          <Route path="invoices" element={<Invoices />} />
                          <Route path="documents" element={<Documents />} />
                          <Route path="reports" element={<Reports />} />
                          <Route path="intelligence" element={<Intelligence />} />
                          <Route path="weather" element={<Weather />} />
                          <Route path="trash" element={<TrashPage />} />
                          <Route path="settings" element={<Settings />} />
                          <Route path="approvals" element={<Approvals />} />
                          <Route path="manual" element={<Manual />} />
                          <Route path="damage" element={<DamageReports />} />
                          <Route path="*" element={<Navigate to="dashboard" replace />} />
                        </Routes>
                      </Layout>
                    </ProtectedRoute>
                  }
                />
                <Route path="*" element={<Navigate to="/app/dashboard" replace />} />
              </Routes>
            </BrowserRouter>
            <ThemedToaster />
            </AuthProvider>
          </I18nProvider>
        </AccessibilityProvider>
      </ThemeProvider>
    </div>
  );
}

function ThemedToaster() {
  const { theme } = useTheme();
  return <Toaster richColors position="top-right" theme={theme} />;
}

export default App;
